import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";

export const usePostCancelarProcessoJudicial = () => {
  const onSuccess = (request: number, response: any) => {
    if (response?.errorMessage) {
      toast.error(response?.errorMessage);
    } else {
      toast.success("Processo cancelado com sucesso!");
      queryClient.invalidateQueries(["processos-judiciais"]);
    }
  };

  return usePost({
    url: `${api.processosJudiciais.postCancelarProcessoJudicial}`,
    onSuccess,
  });
};
